"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
/** A drag that starts in an input must not finish as a canvas click. */
function usePreventMouseUpWhileSelecting(inputRef) {
    const cleanupRef = (0, react_1.useRef)(null);
    (0, react_1.useEffect)(() => () => { var _a; return (_a = cleanupRef.current) === null || _a === void 0 ? void 0 : _a.call(cleanupRef); }, []);
    return () => {
        var _a;
        (_a = cleanupRef.current) === null || _a === void 0 ? void 0 : _a.call(cleanupRef);
        const onMouseUp = (event) => {
            var _a;
            if (event.target !== inputRef.current) {
                event.stopPropagation();
            }
            (_a = cleanupRef.current) === null || _a === void 0 ? void 0 : _a.call(cleanupRef);
        };
        cleanupRef.current = () => {
            window.removeEventListener('mouseup', onMouseUp, true);
            cleanupRef.current = null;
        };
        window.addEventListener('mouseup', onMouseUp, true);
    };
}
exports.default = usePreventMouseUpWhileSelecting;
